// Chargé en tout premier (dans <head>) : indique que JavaScript est actif, pour les animations d'apparition.
// Dans un fichier séparé plutôt qu'en ligne : les règles de sécurité (CSP) n'autorisent que les scripts du site.
// Lit aussi le pays du visiteur mémorisé (choix dans le sélecteur « Langue et pays », ou pays détecté lors
// d'une visite précédente, valable 7 jours) : les prix s'affichent alors tout de suite, et main.js revérifie
// le pays en arrière-plan. Sans pays mémorisé, les prix restent masqués le temps de la détection
// (classe « devise-attente »).
(function () {
  var html = document.documentElement;
  var pays = '';
  html.classList.add('js');
  try {
    pays = localStorage.getItem('kp-pays') || '';
    if (!pays) {
      var geo = JSON.parse(localStorage.getItem('kp-geo') || 'null');
      if (geo && geo.p && Date.now() - geo.t < 7 * 24 * 3600 * 1000) pays = geo.p;
    }
  } catch (e) { /* navigation privée : détection à chaque visite */ }
  pays = 'FR'; // boutique Shopify : prix en euros (France)
  window.KP_PAYS = pays;
  if (!pays) html.classList.add('devise-attente');
})();
